import { emit, off, on } from '@/lib/event-bus';

export default function useEventBus() {
  const handler = {};

  return {
    $on: on(handler),
    $off: off(handler),
    $emit: emit(handler),
  };
}
